<template>
    <div class="information_box">
        <div class="inform_tit">
            <div @click="cancel" class="cancel_box">
                <i class="el-icon-back myback_icon"></i> Back
            </div>
        </div>
        <div class="inMain_box">
            <div class="informdata_tit">Set Venue Information</div>
            <el-form :model="ruleForm" label-position="top" :rules="rules" :hide-required-asterisk="true" ref="ruleForm"
                label-width="100px" class="information-ruleForm">
                <el-form-item label="Venue Name" prop="name">
                    <el-input class="venueInformation_input" maxlength="50" v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item label="Venue Owner" prop="owner">
                    <el-input class="venueInformation_input" maxlength="50" v-model="ruleForm.owner"></el-input>
                </el-form-item>
                <el-form-item label="ABN">
                    <el-input v-model="ruleForm.abn" maxlength="11" class="venueInformation_input"></el-input>
                </el-form-item>
                <el-form-item label="Venue Description">
                    <div class="checkBox_list">
                        <div class="venue_checkBox">
                            <span @click="
                                ruleForm.bar == 1 ? (ruleForm.bar = 0) : (ruleForm.bar = 1)
                                " class="venue_check" :class="{ venue_checked: ruleForm.bar === 1 }"></span>
                            <span class="venueCheckBox_msg" @click="
                                ruleForm.bar == 1 ? (ruleForm.bar = 0) : (ruleForm.bar = 1)
                                ">Bar</span>
                        </div>
                        <div class="venue_checkBox">
                            <span @click="
                                ruleForm.cafe == 1 ? (ruleForm.cafe = 0) : (ruleForm.cafe = 1)
                                " class="venue_check" :class="{ venue_checked: ruleForm.cafe == 1 }"></span>
                            <span class="venueCheckBox_msg" @click="
                                ruleForm.cafe == 1 ? (ruleForm.cafe = 0) : (ruleForm.cafe = 1)
                                ">Cafe</span>
                        </div>
                        <div class="venue_checkBox">
                            <span @click="showDescriptionSel" class="venue_check"
                                :class="{ venue_checked: ruleForm.restaurant == 1 }"></span>
                            <span class="venueCheckBox_msg" @click="showDescriptionSel">Restaurant</span>
                            <transition name="el-zoom-in-center">
                                <el-select v-show="ruleForm.restaurant == 1" v-model="ruleForm.restaurantCkeck"
                                    placeholder="" class="myVenue_sel" :class="{ showSelect: ruleForm.restaurant }">
                                    <el-option v-for="item in [
                                        'Fast Food',
                                        'Quick Service',
                                        'Fast Casual',
                                        'Fine Dining',
                                    ]" :key="item" :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </transition>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="Cuisine Type" prop="age">
                    <el-button icon="el-icon-circle-plus-outline" class="venueAddtype_btn" @click="showCuisDio">Add
                        Type</el-button>
                    <div class="venueType_box" v-for="(item, i) in ruleForm.cuisineCheckd" :key="i">
                        {{ item }}
                        <i class="el-icon-close myclose_icon" @click="ruleForm.cuisineCheckd.splice(i, 1)"></i>
                    </div>
                </el-form-item>
                <el-form-item label="Venue Address" prop="address">
                    <el-input v-model="ruleForm.address" maxlength="100" class="venueInformation_input"></el-input>
                </el-form-item>
                <el-form-item label="Website">
                    <el-input v-model="ruleForm.website" maxlength="100" class="venueInformation_input"></el-input>
                </el-form-item>
                <el-form-item label="Instagram Username">
                    <el-input v-model="ruleForm.username" maxlength="100" class="venueInformation_input"></el-input>
                </el-form-item>
                <el-form-item label="Facebook Page">
                    <el-input v-model="ruleForm.facebook" maxlength="100" class="venueInformation_input"></el-input>
                </el-form-item>
                <el-form-item label="Operating Hours">
                    <el-table :data="ruleForm.hours" border class="venue_table" style="width: 100%">
                        <el-table-column prop="week" align="center" width="150" label-class-name="roster_th"
                            class-name="roster_row" label="Week">
                        </el-table-column>
                        <el-table-column prop="time" align="left" label-class-name="roster_th" class-name="roster_row"
                            label="Time">
                            <template slot-scope="scope">
                                <span v-if="scope.row.time">{{ scope.row.time }}</span>
                                <span v-else>Closed</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="address" align="center" width="250" label-class-name="roster_th"
                            class-name="roster_row" label="Operating">
                            <template slot-scope="scope">
                                <span class="v_table_option_add" @click="addTime(scope.row)">Add</span>
                                <span class="v_table_option_add" @click="delTime(scope.$index, scope.row)"
                                    style="color: #ea3796">Reset</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item class="foot_box">
                    <el-button @click="cancel" class="cardCanBtn">Cancel</el-button>
                    <el-button v-if="!isLoading" @click="confirm" class="cardConBtn">Confirm</el-button>
                    <el-button v-if="isLoading" class="cardConBtn cursor-disable"><i class="el-icon-loading"></i>
                        Saving...</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 选择cuisine -->
        <el-dialog title="Select a cuisine" :visible.sync="cuisineDio" :modal-append-to-body="false" :show-close="false"
            class="editCardDio" :close-on-click-modal="false" width="840px" center>
            <div>
                <el-input v-model="cuisineSearch" placeholder="Start typing to search…" @input="search"
                    class="venueInformation_input"></el-input>
                <div class="cuisineMsg_box">
                    <scroll>
                        <ul class="cuisineMsg_box_ul">
                            <li class="cuisineMsg_box_li" :class="{ checked: isContains(item, cuisineListChecked) }"
                                @click="selectCuis(item)" v-for="(item, i) in cuisineListShow" :key="i">
                                {{ item }}
                            </li>
                        </ul>
                    </scroll>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="
                    (cuisineDio = false),
                    (cuisineListChecked = []),
                    (cuisineListShow = cuisineList),
                    (cuisineSearch = '')
                    " class="cardCanBtn">Cancel</el-button>
                <el-button @click="addCuisin" class="cardConBtn">Add</el-button>
            </span>
        </el-dialog>

        <!-- 添加时间 -->
        <timePicker v-if="addTimeDio" :addTimeDio="addTimeDio" @cancel="addTimeDio = false" @add="addTimed">
        </timePicker>

        <el-dialog :visible.sync="isTrialEnd" class="peiso-modal" width="810px" :show-close="false"
            :close-on-click-modal="false" :close-on-press-escape="false">
            <free-trial-notice :info="venueDiscountDetailsPojo" :isPro="isPro"
                @close-notice="closeOrLogoutVenue"></free-trial-notice>
        </el-dialog>
    </div>
</template>

<script>
import timePicker from "../common/timepicker.vue";
import scroll from "../common/scroll.vue";
import api from "../../api/api";
import freeTrialNotice from "@/components/modal/freeTrialNotice";
import Utils from "@/utils/utils";
export default {
    data() {
        var checkabn = (rule, value, callback) => {
            if (!value) {
                return callback(new Error(""));
            }
            setTimeout(() => {
                if (value.length < 11) {
                    callback(new Error("Please enter an 11-digit ABN"));
                } else {
                    callback();
                }
            }, 200);
        };
        return {
            cuisineDio: false,
            cuisineSearch: "", // 选项搜索关键字
            cuisineList: [
                // 选项源数据
                "Afghan",
                "African",
                "American",
                "Arabian",
                "Argentine",
                "Asian",
                "Asian Fusion",
                "Australian",
                "Austrian",
                "BBQ",
                "Bakery",
                "Bangladeshi",
                "Bar Food",
                "Basque",
                "Belgian",
                "Beverages",
                "Brazilian",
                "British",
                "Bubble Tea",
                "Burger",
                "Burmese",
                "Cabinet Food",
                "Cafe Food",
                "Cambodian",
                "Cantonese",
                "Caribbean",
                "Charcoal Chicken",
                "Chinese",
                "Coffee and Tea",
                "Colombian",
                "Contemporary",
                "Continental",
                "Creole",
                "Crepes",
                "Croatian",
                "Danish",
                "Deli",
                "Desserts",
                "Drinks Only",
                "Dumplings",
                "Dutch",
                "Eastern European",
                "Egyptian",
                "Ethiopian",
                "European",
                "Falafel",
                "Filipino",
                "Finger Food",
                "Fish and Chips",
                "French",
                "Fried Chicken",
                "Frozen Yogurt",
                "Fusion",
                "Georgian",
                "German",
                "Greek",
                "Grill",
                "Hawaiian",
                "Healthy Food",
                "Hot Pot",
                "Hungarian",
                "Ice Cream",
                "Indian",
                "Indonesian",
                "International",
                "Iranian",
                "Iraqi",
                "Irish",
                "Israeli",
                "Italian",
                "Japanese",
                "Japanese BBQ",
                "Jewish",
                "Juices",
                "Kebab",
                "Korean",
                "Korean BBQ",
                "Latin American",
                "Lebanese",
                "Malatang",
                "Malaysian",
                "Mauritian",
                "Meat Pie",
                "Mediterranean",
                "Mexican",
                "Middle Eastern",
                "Modern Australian",
                "Modern European",
                "Mongolian",
                "Moroccan",
                "Nepalese",
                "North Indian",
                "Pacific",
                "Pakistani",
                "Pan Asian",
                "Parma",
                "Pastry",
                "Patisserie",
                "Peruvian",
                "Pho",
                "Pizza",
                "Poké",
                "Polish",
                "Portuguese",
                "Pub Food",
                "Ramen",
                "Roast",
                "Russian",
                "Salad",
                "Sandwich",
                "Satay",
                "Scandinavian",
                "Scottish",
                "Seafood",
                "Shanghai",
                "Sichuan",
                "Singaporean",
                "Soul Food",
                "South African",
                "South Indian",
                "Spanish",
                "Sri Lankan",
                "Steak",
                "Street Food",
                "Sushi",
                "Swedish",
                "Swiss",
                "Syrian",
                "Taiwanese",
                "Tapas",
                "Tea",
                "Teppanyaki",
                "Teriyaki",
                "Tex-Mex",
                "Thai",
                "Tibetan",
                "Turkish",
                "Ukrainian",
                "Uruguayan",
                "Uyghur",
                "Vegan",
                "Vegetarian",
                "Venezuelan",
                "Vietnamese",
                "Yum Cha",
            ],
            cuisineListShow: [], // 选项展示数据
            cuisineListChecked: [], // 选项选中数据，未b保存
            addTimeDio: false,
            addTimeDay: "", //添加时间标识
            rules: {
                // 表单验证
                name: [{ required: true, message: " ", trigger: "blur" }],
                owner: [{ required: true, message: " ", trigger: "blur" }],
                abn: [{ validator: checkabn, trigger: "blur" }],
                address: [{ required: true, message: " ", trigger: "blur" }],
                website: [{ required: true, message: " ", trigger: "blur" }],
                username: [{ required: true, message: " ", trigger: "blur" }],
                facebook: [{ required: true, message: " ", trigger: "blur" }],
            },
            timeNum: 0,
            itemTime: "",
            ruleForm: {
                // 表单数据
                name: "",
                owner: "",
                abn: "",
                address: "",
                timezone: "",
                website: "",
                username: "",
                facebook: "",
                description: [],
                bar: 0,
                cafe: 0,
                restaurant: 0,
                cuisineCheckd: [], //cuisine type 选中的值
                restaurantCkeck: "Fast Food",
                hours: [
                    { week: "Mon", time: "" },
                    { week: "Tues", time: "" },
                    { week: "Wed", time: "" },
                    { week: "Thu", time: "" },
                    { week: "Fri", time: "" },
                    { week: "Sat", time: "" },
                    { week: "Sun", time: "" },
                ],
            },
            isPro: false,
            isDoneLoad: false,
            venueDiscountDetailsPojo: null,
            isTrialEnd: false,
            isLoading: false,
        };
    },
    components: {
        timePicker,
        scroll,
        freeTrialNotice: freeTrialNotice,
    },
    methods: {
        showDescriptionSel() {
            this.ruleForm.restaurant == 1
                ? (this.ruleForm.restaurant = 0)
                : (this.ruleForm.restaurant = 1);
            if (this.ruleForm.restaurant == 0)
                this.ruleForm.restaurantCkeck = "Fast Food";
        },
        showCuisDio() {
            this.cuisineDio = true;
            this.cuisineListShow = this.cuisineList;
            this.cuisineListChecked = this.cuisineListChecked.concat(
                JSON.parse(JSON.stringify(this.ruleForm.cuisineCheckd))
            );
        },
        search() {
            // 搜索选项
            const filtList = Object.assign(this.cuisineList, {});
            let arr = filtList.filter((item) => {
                return (
                    item.toLowerCase().indexOf(this.cuisineSearch.toLowerCase()) != -1
                );
            });
            this.cuisineListShow = arr;
        },
        selectCuis(item) {
            // 选中 or 取消
            if (!this.isContains(item, this.cuisineListChecked)) {
                if (this.cuisineListChecked.length < 10) {

                } else {
                    //
                }
                this.cuisineListChecked.push(item);
            } else {
                let ii = this.cuisineListChecked.findIndex((val) => val == item);
                if (ii >= 0) {
                    this.cuisineListChecked.splice(ii, 1);
                }
            }
        },
        addCuisin() {
            // 添加选项
            if (this.cuisineListChecked.length > 10) {
                this.$message.error("A maximum of 10 cuisine type can be added")
                this.cuisineDio = false;
            } else {
                this.ruleForm.cuisineCheckd = JSON.parse(
                    JSON.stringify(this.cuisineListChecked)
                );
            }
            this.cuisineListChecked = [];
            this.cuisineDio = false;
        },
        addTime(val) {
            // 打开时间弹框
            var extract = val.time.split(',')
            if (extract.length == 3) {
                Utils.alert2(
                    "",
                    "Error, You can only add 1-3 times of time schedule.",
                    "error"
                );
                return
            }
            this.addTimeDay = val.week;
            this.addTimeDio = true;
        },
        delTime(i, val) {
            // 删除时间
            this.ruleForm.hours[i].time = "";
        },
        addTimed(val) {
            // 添加时间
            this.timeNum = 0;
            this.ruleForm.hours.forEach((item) => {
                if (item.week == this.addTimeDay) {
                    let arr = item.time ? item.time.split(",") : [];
                    arr.push(val);
                    item.time = arr.join(",");
                }
                if (item.time) {
                    this.itemTime = item.time;
                    this.timeNum++;
                }
            });
            if (this.timeNum == 1) {
                // 只有一个时间
                this.ruleForm.hours.forEach((item) => {
                    item.time = this.itemTime;
                });
            }
            this.addTimeDio = false;
        },
        cancel() {
            // 返回
            this.$router.push({ path: "/setting" });
        },
        confirm() {
            // 提交
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    this.isLoading = true;
                    let pat = {
                        venueName: this.ruleForm.name,
                        venueOwner: this.ruleForm.owner,
                        abn: this.ruleForm.abn,
                        venueDescription: "",
                        cuisineType: this.ruleForm.cuisineCheckd.join(","),
                        venueAddress: this.ruleForm.address,
                        timezone: this.ruleForm.timezone,
                        website: this.ruleForm.website,
                        instagramUsername: this.ruleForm.username,
                        facebookPage: this.ruleForm.facebook,
                        venueAddress: this.ruleForm.address,
                        venueOpenUpdateVoList: [],
                    };
                    // 描述
                    let descriptionList = [];
                    this.ruleForm.bar ? descriptionList.push("Bar") : "";
                    this.ruleForm.cafe ? descriptionList.push("Cafe") : "";
                    this.ruleForm.restaurant
                        ? descriptionList.push(this.ruleForm.restaurantCkeck)
                        : "";
                    pat.venueDescription = descriptionList.join(",");
                    // 时间
                    pat.venueOpenUpdateVoList = this.ruleForm.hours.map((item) => {
                        let obj = {
                            week:
                                item.week == "Mon"
                                    ? "Monday"
                                    : item.week == "Tues"
                                        ? "Tuesday"
                                        : item.week == "Thu"
                                            ? "Thursday"
                                            : item.week == "Fri"
                                                ? "Friday"
                                                : item.week == "Sat"
                                                    ? "Saturday"
                                                    : item.week == "Sun"
                                                        ? "Sunday"
                                                        : "Wednesday",
                            openTime: item.time,
                        };
                        return obj;
                    });
                    api.setVenueInfo(pat, (res) => {
                        let { code, data, message } = res.data;
                        if (code == 0) {
                            Utils.alert2(
                                "",
                                "Venue information successfully updated.",
                                "success"
                            );
                            this.$router.push({ path: "/setting" });
                        } else {
                            Utils.alert2("", message, "error");
                        }
                        this.isLoading = false;
                    });
                } else {
                    Utils.alert2("", "Failed to save venue information", "error");
                    return false;
                }
            });
        },
        getdetail() {
            api.getVenueInfo({}, (res) => {
                let { code, data, message } = res.data;
                if (code == 0) {
                    this.ruleForm.name = data.venueName;
                    this.ruleForm.owner = data.venueOwner;
                    this.ruleForm.abn = data.abn;
                    this.cuisineListShow = data.cuisineType.split(",");
                    this.ruleForm.cuisineCheckd = data.cuisineType.split(",");
                    this.ruleForm.address = data.venueAddress;
                    this.ruleForm.website = data.website;
                    this.ruleForm.username = data.instagramUsername;
                    this.ruleForm.facebook = data.facebookPage;
                    this.ruleForm.timezone = sessionStorage.getItem("zoneId");

                    data.venueDescription.split(",").forEach((item) => {
                        switch (item) {
                            case "Bar":
                                this.ruleForm.bar = 1;
                                break;
                            case "Cafe":
                                this.ruleForm.cafe = 1;
                                break;
                            case "Café":
                                this.ruleForm.cafe = 1;
                                break;
                            default:
                                if (item) {
                                    this.ruleForm.restaurant = 1;
                                    this.ruleForm.restaurantCkeck = item;
                                }
                                break;
                        }
                    });
                    if (data.venueOpenList.length) {
                        this.ruleForm.hours = data.venueOpenList.map((item) => {
                            switch (item.week) {
                                case "Monday":
                                    return {
                                        week: "Mon",
                                        time: item.openTime != "Closed" ? item.openTime : "",
                                    };
                                    break;
                                case "Tuesday":
                                    return {
                                        week: "Tues",
                                        time: item.openTime != "Closed" ? item.openTime : "",
                                    };
                                    break;
                                case "Thursday":
                                    return {
                                        week: "Thu",
                                        time: item.openTime != "Closed" ? item.openTime : "",
                                    };
                                    break;
                                case "Friday":
                                    return {
                                        week: "Fri",
                                        time: item.openTime != "Closed" ? item.openTime : "",
                                    };
                                    break;
                                case "Saturday":
                                    return {
                                        week: "Sat",
                                        time: item.openTime != "Closed" ? item.openTime : "",
                                    };
                                    break;
                                case "Sunday":
                                    return {
                                        week: "Sun",
                                        time: item.openTime != "Closed" ? item.openTime : "",
                                    };
                                    break;
                                case "Wednesday":
                                    return {
                                        week: "Wed",
                                        time: item.openTime != "Closed" ? item.openTime : "",
                                    };
                                    break;
                            }
                        });
                    }
                } else {
                    Utils.alert("", message, "error");
                }
            });
        },

        closeOrLogoutVenue(isSubscribe) {
            if (isSubscribe) {
                this.isTrialEnd = false;
                return;
            }
            if (this.venueDiscountDetailsPojo.remainingDays <= 0) {
                this.$root.$emit("logout-venue");
            } else {
                const isContUsingTrial = sessionStorage.getItem("isContUsingTrial");
                if (isContUsingTrial == "0") {
                    sessionStorage.setItem("isContUsingTrial", "1");
                }
                this.isTrialEnd = false;
            }
        },
    },
    mounted() {
        this.getdetail();

        this.$root.$on("isPro", (isPro, others) => {
            this.isPro = isPro;
            this.isDoneLoad = true;

            const isContUsingTrial = sessionStorage.getItem("isContUsingTrial");
            if (
                others.venueDiscountDetailsPojo &&
                others.venueDiscountDetailsPojo.remainingDays <= 3 &&
                isContUsingTrial == "0"
            ) {
                this.venueDiscountDetailsPojo = others.venueDiscountDetailsPojo;
                this.isTrialEnd = true;
            }
        });
    },
    computed: {
        abn() {
            return this.ruleForm.abn;
        },
    },
    watch: {
        abn(n, o) {
            if (n != "") {
                let reg = /^\d+(\d)?$/;
                if (new RegExp(reg).test(n) == false) {
                    setTimeout(() => {
                        this.ruleForm.abn = o;
                    }, 50);
                }
            }
        },
    },
};
</script>

<style lang="scss">
.information_box {
    position: relative;

    .inform_tit {
        height: 76px;
        font-size: 14px;
        font-weight: 600;
        color: var(--text-color);
        line-height: 20px;
        width: 100%;
        background-color: var(--background-color);
        z-index: 100;

        .cancel_box {
            cursor: pointer;
            width: 150px;
        }
    }

    .inMain_box {
        background-color: var(--background-color-4);
        width: 100%;
        box-sizing: border-box;
        padding: 50px 15%;
        margin-bottom: 40px;

        .informdata_tit {
            text-align: center;
            margin-bottom: 50px;
            height: 42px;
            font-size: 30px;
            font-weight: 600;
            color: var(--text-color);
            line-height: 42px;
        }

        .checkBox_list {
            display: flex;
            height: 40px;
            align-items: center;
        }

        .venue_checkBox {
            display: flex;
            align-items: center;
            margin-right: 65px;

            .venue_check {
                width: 16px;
                height: 16px;
                box-sizing: border-box;
                background: var(--background-color);
                border-radius: 1px;
                border: 1px solid rgba(95, 95, 95, 1);
                margin-right: 10px;
                cursor: pointer;
            }

            .venue_checked {
                width: 16px;
                height: 16px;
                border: none;
                background: url("../../../static/img/correct.png");
                background-size: cover;
                border-radius: 1px;
                background-repeat: no-repeat;
                margin-right: 10px;
                cursor: pointer;
            }

            .venueCheckBox_msg {
                cursor: pointer;
                height: 28px;
                width: 100px;
                font-size: 20px;
                font-weight: 400;
                color: var(--text-color);
                line-height: 28px;
            }
        }

        .venueAddtype_btn {
            width: 150px;
            height: 40px;
            padding: 10px 20px !important;
            background: var(--background-color);
            border: 1px solid rgba(209, 58, 144, 1);
            font-size: 20px;
            font-weight: 400;
            color: rgba(209, 58, 144, 1);
            margin-right: 30px;
        }

        .venueType_box {
            display: inline-block;
            padding: 0 20px;
            height: 40px;
            line-height: 40px;
            background: rgba(21, 28, 39, 1);
            border: 1px solid rgba(95, 95, 95, 1);
            font-size: 20px;
            color: #fff;
            vertical-align: top;
            box-sizing: border-box;
            margin: 20px 30px 0 0;
            position: relative;
            border-radius: 4px;

            .myclose_icon {
                position: absolute;
                top: -12px;
                right: -12px;
                background-color: var(--text-color);
                color: var(--background-color-3);
                width: 20px;
                height: 20px;
                border-radius: 50%;
                font-size: 15px;
                font-weight: 600;
                line-height: 20px;
                text-align: center;
                cursor: pointer;
            }
        }

        .v_table_option_add {
            height: 25px;
            font-size: 18px;
            font-weight: 400;
            color: var(--text-color);
            line-height: 25px;
            margin-right: 25px;
            cursor: pointer;

            &:last-child {
                margin-right: 0px;
            }
        }
    }
}

.checked {
    color: var(--primary-color) !important;
}

.leftIn-enter-active,
.leftIn-in-leave-active {
    width: 200px;
    transition: opacity 0.4s ease;
}

.leftIn-in-enter,
.leftIn-in-leave-to {
    opacity: 0;
    width: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/setting/setInformation.vue